import { createContext, useContext, useEffect, useState } from 'react';
import { useSnackbar } from "notistack";
import { LOGIN } from "../constants/urls";
import jwt from '../services/jwt';

export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
    const { enqueueSnackbar } = useSnackbar();

    const [ isAuthenticated, setIsAuthenticated ] = useState(false);

    const checkTokenExpiration = () => {
        const token = jwt.getToken();
        if (!token){
            if (window.location.pathname === LOGIN){
              return;
            } else {
                setIsAuthenticated(false);
            }
        }

        try {
            if (jwt.isExpired(token)) {
                enqueueSnackbar('Su sesión ha expirado, por favor vuelva a iniciar sesión',
                    { variant: 'warning' }
                );
                jwt.removeToken();
                setIsAuthenticated(false);
            } else {
                setIsAuthenticated(true)
            }
        } catch (e){
            jwt.removeToken();
            setIsAuthenticated(false);
        }
    }

    useEffect(() => {
        const interval = jwt.getTokenExpirationTimestamp() - Date.now() + 1;
        checkTokenExpiration();

        let intervalId;
        if (interval > 0) {
            intervalId = setInterval(checkTokenExpiration, interval);
        }
        return () => {
            if (interval > 0 && intervalId) {
                clearInterval(intervalId);
            }
        };
    },[]);

    return (
        <AuthContext.Provider value={{ isAuthenticated }}>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthProvider;